import { Component, OnInit,ViewChild } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
import { Router} from '@angular/router';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/Template/Period.html'
})

export class PeriodsComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
    public PeriodData: any = [];
    public PeriodList: any = [];
    public TeamList: any = [];
    public ReviewTemplateList: any = [];
    public ReviewEmployeeList : any = [];
    public ReviewTemplateId:any = null;
    public IsOpenPeriodActive = false;
    public showLoader = false;
    

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService,private _route: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    }

    ngOnInit() {
        this.getPeriodList();
      
    }

    ngAfterViewInit() {

        $(".date").datetimepicker({
            format: 'DD/MM/YYYY'
        });
        $(".dateYear").datetimepicker({
            format: 'YYYY',
            maxDate:moment().set({hour:0,minute:0,second:0,millisecond:0})
        });
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }

    public CancelAddPeriod(){
        this.PeriodData ={ PeriodId: null,
            PeriodText : "",
         //   PeriodStartDate: moment(new Date()).format('DD/MM/YYYY'),
           // PeriodEndDate :moment(new Date()).format('DD/MM/YYYY')
           PeriodStartDate :null,
           PeriodEndDate : null,
           IsActive:true


        };
    }
    CreateNewPeriod(){
        this.CancelAddPeriod();
        this.IsOpenPeriodActive = false;
    }
    public EditTeam(item){
        this.IsOpenPeriodActive = false;
        this.PeriodData =item;
        var tPeriodEndDate = moment(this.PeriodData.PeriodEndDate, "DD/MM/YYYY");
                var tPeriodStartDate = moment(moment(new Date()).format('DD/MM/YYYY'), "DD/MM/YYYY");
                if(tPeriodEndDate < tPeriodStartDate )
                         this.IsOpenPeriodActive = true;
    }
     public AddUpdatePeriod(form: any) {
       
         if (form.form.valid) {
   
             if(this.validateReviewReviewDetails())
             {
                this.showLoader = true;
             this._httpService.ajaxPost('ReviewEmployeeList/AddUpdatePeriod', {"PeriodId" :this.PeriodData.PeriodId,"PeriodText" :this.PeriodData.PeriodText,"PeriodStartDate" :this.PeriodData.PeriodStartDate,"PeriodEndDate" :this.PeriodData.PeriodEndDate,"IsActive":this.PeriodData.IsActive}).subscribe(
                 data => {
                    //this.PeriodList = data["PeriodList"];
                    this.CancelAddPeriod();
                    this.getPeriodList();
                    $('#addPeriod').modal('hide');
                    this._sharedService.ShowMessage("success|Data Updated Successfully");
                },
                err => {
                     this.showLoader = false;
                     this._sharedService.ShowMessage(this.constants.globalError);
                },
                 () => {
                     this.showLoader = false;
                 }
             );

         }
                                
        }
        
     }

     OpenReview()
     {
    
     this.showLoader = true;
        this._httpService.ajaxPost('ReviewEmployeeList/OpenReview', {"PeriodId" :this.PeriodData.PeriodId}).subscribe(
            data => {
               //this.PeriodList = data["PeriodList"];
               this.CancelAddPeriod();
               this.getPeriodList();
               $('#addPeriod').modal('hide');
               this._sharedService.ShowMessage("success|Data Updated Successfully");
           },
           err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
           },
            () => {
                this.showLoader = false;
            }
        );

}



CloseReview()
{

this.showLoader = true;
   this._httpService.ajaxPost('ReviewEmployeeList/CloseReview', {"PeriodId" :this.PeriodData.PeriodId}).subscribe(
       data => {
          //this.PeriodList = data["PeriodList"];
          this.CancelAddPeriod();
          this.getPeriodList();
          $('#addPeriod').modal('hide');
          this._sharedService.ShowMessage("success|Data Updated Successfully");
      },
      err => {
           this.showLoader = false;
           this._sharedService.ShowMessage(this.constants.globalError);
      },
       () => {
           this.showLoader = false;
       }
   );
    }
    public getPeriodList() {
        this.showLoader = true;
        this._httpService.ajaxPost('ReviewEmployeeList/GetPeriod',null).subscribe(
            data => {
                this.PeriodList = data["PeriodList"];
                 
            },
            err => {
                this.showLoader = false;
              
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    
    
    
    validateReviewReviewDetails(){
        var mandatory = "";
        var invalid = "";
        var functional = "";

       
           
                if(this.PeriodData.PeriodStartDate == "" || this.PeriodData.PeriodStartDate == null)
                {
                    mandatory = mandatory + "<br>Period Start Date ";
                }
                if(this.PeriodData.PeriodEndDate == "" || this.PeriodData.PeriodEndDate == null)
                {
                    mandatory = mandatory + "<br>Period End Date";
                }

                if(this.PeriodData.PeriodText == "" || this.PeriodData.PeriodText == null)
                {
                    mandatory = mandatory + "<br>Period Name";
                }
               
                var tPeriodEndDate = moment(this.PeriodData.PeriodEndDate, "DD/MM/YYYY");
                var tPeriodStartDate = moment(this.PeriodData.PeriodStartDate, "DD/MM/YYYY");
                if(tPeriodEndDate <= tPeriodStartDate )
                {
                    mandatory = mandatory + "<br>Period End Date should be greater than Period end date";
                }
      

        if (mandatory == "" && invalid == "" && functional == "") {
            return true;
        } else {
            var msg = "";
            if (mandatory != "") {
                msg = msg + "Please enter : " + mandatory;
                msg = msg + "<br>";
            }
            if (invalid != "") {
                msg = msg + "Please enter valid : " + invalid;
                msg = msg + "<br>";
            }
            if (functional != "") {
                msg = msg + functional;
            }
            this._sharedService.ShowMessage("error|" + msg);
        }
        return false;

    }
   
   
         
        
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Template/Periods.component.ts
 **/